import { loadTossPayments } from '@tosspayments/tosspayments-sdk';

const CLIENT_KEY = process.env.REACT_APP_TOSS_CLIENT_KEY ?? '';

/** 토스페이먼츠 SDK 초기화 */
export async function initTossPayments() {
  return loadTossPayments(CLIENT_KEY);
}

/** 결제위젯 인스턴스 생성 */
export async function createPaymentWidgets(customerKey: string) {
  const tossPayments = await initTossPayments();
  return tossPayments.widgets({ customerKey });
}
